export default function parseHexString(str: string) {
  const bytes = [];
  for (let c = 0; c < str.length; c += 2)
    bytes.push(parseInt(str.substr(c, 2), 16));
  return bytes;
}
